module.exports = __webpack_public_path__ + "img/aq.d9662482.svg";